/* Suresh Peddavoora 10/28/2022 3075154998  Added Class Name for Text Fields and Buttons
 Lalitha            11/9/2022  3075154998 Rename Button Cancel to Reset
Prakash Gummala 11/10/2022  3075154998 Fixed TextFields Alignments.
*/
import React, {useEffect, useState, useContext} from 'react';
import {Formik} from 'formik';
import {Button, Grid, TextField, InputAdornment} from '@material-ui/core';
import {DISPOSITION_CODE} from '../../../../../../constants/Lookup';
import {useDispatch, useSelector} from 'react-redux';
import {fetchDispositionCodes} from '../../../../../../redux/reducers/EventTactics/EventTactics';
import SearchRecordFormat from '../../../../RecordFormat/SearchRecordFormat';
import {
  handleRecordFormatSearchField,
  resettingFieldData,
} from '../../../../../../redux/reducers/BRE/AddRecordFormat';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import {ArrowBack, Search, Clear} from '@material-ui/icons';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';

const ActionForm = ({
  setActionData,
  actionData,
  setActionOpen,
  actionRowData,
  isEditMode,
  setIsEditMode,
  actionCode,
  setParameter,
}) => {
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {dispositionDropDown} = useSelector(({addEventTactic}) => addEventTactic);
  const [showSearchFieldData, setShowSearchFieldData] = useState(false);
  const initialValues = {
    operator: isEditMode && actionRowData?.operator ? actionRowData?.operator : '',
    fieldOne: isEditMode && actionRowData?.fieldOne ? actionRowData?.fieldOne : '',
    fieldCode: '',
    sourceField: isEditMode && actionRowData?.sourceField ? actionRowData?.sourceField : '',
    fieldFormat: isEditMode && actionRowData?.fieldFormat ? actionRowData?.fieldFormat : '',
    filterAction: isEditMode && actionRowData?.filterAction ? actionRowData?.filterAction : '',
    recordFormat: isEditMode && actionRowData?.recordFormat ? actionRowData?.recordFormat : '',
    actionParamOne:
      isEditMode && actionRowData?.actionParamOne ? actionRowData?.actionParamOne : '',
    actionName: isEditMode && actionRowData?.actionName ? actionRowData?.actionName : '',
    description: isEditMode && actionRowData?.description ? actionRowData?.description : '',
    returnType: isEditMode && actionRowData?.returnType ? actionRowData?.returnType : '',
  };

  const dataTypeOptions = [
    {key: 'Set', value: 'Set'},
    {key: 'Change Disposition', value: 'Change Disposition'},
    {key: 'Make Report Line', value: 'Make Report Line'},
    {key: 'Make Record', value: 'Make Record'},
  ];

  const dateFormatOptions = [
    {key: 'MDY', value: 'MDY'},
    {key: 'YMD', value: 'YMD'},
  ];
  useEffect(() => {
    dispatch(fetchDispositionCodes());
  }, []);
  const getOptions = (typeCode) => {
    let label = [];
    label =
      dispositionDropDown && dispositionDropDown[typeCode] ? dispositionDropDown[typeCode] : [];

    return label;
  };
  const handleSubmit = (data) => {
    const copiedData = [...actionData];
    if (!isEditMode) {
      copiedData.push({...data});
      setActionData(copiedData);
      setActionOpen(false);
    } else {
      const updatedActionData = copiedData.map((item, i) => {
        if (i === actionCode) {
          return {
            ...item,
            operator: data?.operator,
            fieldOne: data?.fieldOne,
            fieldCode: '',
            sourceField: data?.sourceField,
            fieldFormat: data?.fieldFormat,
            type: data?.type,
            recordFormat: data?.recordFormat,
            actionParamOne: data?.actionParamOne,
            actionName: data?.actionName,
            description: data?.description,
            returnType: data?.returnType,
            sequenceNo: i + 1,
            disposition: data?.disposition,
          };
        } else {
          return {...item};
        }
      });
      setActionData(updatedActionData);
      setActionOpen(false);
      setIsEditMode(false);
    }
  };
  return (
    <div className={classes.dialoguecardStyles}>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
      >
        {(props) => {
          const {values, handleChange, handleSubmit, handleReset, handleBlur, setFieldValue} =
            props;
          return (
            <div>
              {showSearchFieldData ? (
                <>
                  <Button
                    variant="text"
                    className={`"mb-2" ${classes.goBackBtn}`}
                    onClick={() => {
                      setShowSearchFieldData(false);
                    }}
                  >
                    <ArrowBack className="mr-2" />
                    Go Back
                  </Button>
                  <SearchRecordFormat />
                </>
              ) : (
                <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                  <div className="global-field-textfields">
                    <Grid container spacing={2}>
                      <Grid sm={6} md={4} item className=" form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="filterAction"
                          id="type"
                          size="small"
                          value={values.filterAction}
                          options={dataTypeOptions.map((item) => item.value)}
                          onChange={(e, value) => {
                            setFieldValue('filterAction', value);
                            setFieldValue('recordFormat', '');
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={` ${classes.labelName} ${classes.selectLabel}`}
                                variant="outlined"
                                margin="dense"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                label="Action Type"
                                placeholder="Select Action Type"
                              />
                            </div>
                          )}
                        />
                      </Grid>

                      {values.filterAction === 'Set' && (
                        <Grid container>
                          <Grid sm={6} md={4} item className=" form-group">
                            <TextField
                              margin="dense"
                              className={` ${classes.labelName} ${classes.inputLabel}`}
                              variant="outlined"
                              placeholder="Enter To Field"
                              label="To Field"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name="fieldOne"
                              value={values.fieldOne}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              fullWidth
                            />
                          </Grid>
                          <Grid sm={6} md={4} item className=" form-group">
                            <TextField
                              margin="dense"
                              className={` ${classes.labelName} ${classes.inputLabel}`}
                              variant="outlined"
                              placeholder={`Enter actionParamOne`}
                              label="actionParamOne"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name="actionParamOne"
                              value={values.actionParamOne}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              fullWidth
                            />
                          </Grid>
                          <Grid sm={6} md={4} item className=" form-group">
                            <GuiAutoComplete
                              classes={{
                                option: classes.option,
                              }}
                              name="fieldFormat"
                              id="fieldFormat"
                              size="small"
                              value={values.fieldFormat}
                              options={dateFormatOptions.map((item) => item.value)}
                              onChange={(e, value) => {
                                setFieldValue('fieldFormat', value);
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    {...params}
                                    variant="outlined"
                                    className={` ${classes.labelName} ${classes.selectLabel}`}
                                    margin="dense"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    label="Date Format"
                                    placeholder="Select Date Format"
                                  />
                                </div>
                              )}
                            />
                          </Grid>
                        </Grid>
                      )}
                      {values.filterAction === 'Change Disposition' && (
                        <Grid sm={6} md={4} item className=" form-group">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            id="disposition"
                            size="small"
                            value={values.disposition}
                            onChange={(e, value) => {
                              setFieldValue('disposition', value);
                            }}
                            options={getOptions(DISPOSITION_CODE)}
                            getOptionLabel={(option) => {
                              return option && option.value ?
                                option.valueCode === null ?
                                  option.value :
                                  option.valueCode + ' - ' + option.value :
                                '';
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  variant="outlined"
                                  className={` ${classes.labelName} ${classes.selectLabel}`}
                                  margin="dense"
                                  name="disposition"
                                  InputLabelProps={{shrink: true}}
                                  label={'Status'}
                                  placeholder={`Select Status`}
                                />
                              </div>
                            )}
                          />
                        </Grid>
                      )}
                      {values.filterAction === 'Make Report Line' && (
                        <Grid sm={6} md={4} item className=" form-group">
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            placeholder="Enter Record Format"
                            label="Record Format"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="recordFormat"
                            value={values.recordFormat}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            disabled
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Search
                                    className={` ${classes.iconSearch}`}
                                    onClick={() => {
                                      setShowSearchFieldData(true);
                                      // dispatch(
                                      //   handleRecordFormatSearchField({
                                      //     status: true,
                                      //     setFieldValue,
                                      //     setShowSearchFieldData,
                                      //   })
                                      // );
                                    }}
                                  >
                                    Search
                                  </Search>
                                  <Clear
                                    className={` ${classes.iconSearch}`}
                                    onClick={(e) => setFieldValue('recordFormat', '')}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                      )}
                      {values.filterAction === 'Make Record' && (
                        <Grid sm={6} md={4} item className=" form-group">
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            placeholder="Enter Record Format"
                            label="Record Format"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="recordFormat"
                            value={values.recordFormat}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled
                            fullWidth
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Search
                                    className={` ${classes.iconSearch}`}
                                    onClick={() => {
                                      setShowSearchFieldData(true);
                                      dispatch(
                                        handleRecordFormatSearchField({
                                          status: true,
                                          setFieldValue,
                                          setShowSearchFieldData,
                                        }),
                                      );
                                    }}
                                  >
                                    Search
                                  </Search>
                                  <Clear
                                    className={` ${classes.iconSearch}`}
                                    onClick={(e) => setFieldValue('recordFormat', '')}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </div>
                  <div className="text-center">
                    <div className="button-spacing-mb">
                      <Button
                        type="button"
                        onClick={() => handleReset()}
                        variant="outlined"
                        className={`reset-btn mx-1 ${classes.buttonRoot}`}
                      >
                        Reset
                      </Button>
                      <Button
                        type="submit"
                        variant="outlined"
                        className={`search-btn mx-1 ${classes.buttonRoot}`}
                        onClick={() => dispatch(resettingFieldData())}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default ActionForm;
